var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarBurst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 1.5 1.5 6.3L19 4.4l-2.8 5.8 6.3-.8-5.6 3.2 5.2 3.7-6.2-1.4 2.2 6-5.1-3.9-1 6.3-1.5-6.2-4.6 4.3 1.8-6.2-6 2.1 4.8-4.2-6-2.6 6.4.2-3.4-5.4 5.8 2.8L12 1.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarBurst);
export default __webpack_public_path__ + "static/media/icon_star_burst.86741d113bd962bb3b47836ab4652bc2.svg";
export { ForwardRef as ReactComponent };